import { __decorate, __metadata } from "tslib";
import { Component, Inject, Prop } from "vue-property-decorator";
import { SYM_LV_FORM_ITEM } from "../form-item/LvFormItem.vue";
import { UIComponent } from "../UIComponent";
export const COMPONENT_NAME = "LvField";
/**
 * A wrapper to decorate native HTML `<input>` and `<select>`
 */
let LvField = class LvField extends UIComponent {
    get displayedLabel() {
        return this.label ?? this.formItem?.label;
    }
    get classList() {
        return [
            this.showLabel && this.displayedLabel ? "has-label" : null,
        ].filter(x => x != null);
    }
};
__decorate([
    Prop({ type: String, required: false, default: null }),
    __metadata("design:type", String)
], LvField.prototype, "label", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: true }),
    __metadata("design:type", Boolean)
], LvField.prototype, "showLabel", void 0);
__decorate([
    Inject({ default: null, from: SYM_LV_FORM_ITEM }),
    __metadata("design:type", Object)
], LvField.prototype, "formItem", void 0);
LvField = __decorate([
    Component({
        name: COMPONENT_NAME,
    })
], LvField);
export default LvField;
//# sourceMappingURL=script.js.map